import api from './api';

export function getDataValidacion(idCredit) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/validacion-identidad/${idCredit}`)
  }

export function postEnviarNotificacion(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/validacion-identidad/enviar-notificacion`,data)
  }

  